import { memo } from 'react';
import type { TableDTO } from '@six-pockets/shared';
import { NO_SELECTION } from '@/context/TablesContext';
import { TableCard } from './TableCard';
import styles from '@/styles/components/TableGrid/style.scss';

interface TableGridProps {
  tables: TableDTO[];
  selection: Record<string, string[]>;
  /** Bookings are ticked on more than one table: Generate Bill is in the page header, not on the cards. */
  multiTable: boolean;
  onGenerateBill: () => void;
}

/**
 * The cards. Each gets only its own table, its own ticked ids and stable callbacks, so a change on one table
 * (or a checkbox on it) re-renders that card alone.
 */
export const TableGrid = memo(function TableGrid({ tables, selection, multiTable, onGenerateBill }: TableGridProps) {
  return (
    <section aria-label="Tables" className={styles.grid}>
      {tables.map((t) => (
        <TableCard
          key={t.id}
          table={t}
          selectedIds={selection[t.id] ?? NO_SELECTION}
          onGenerateBill={multiTable ? undefined : onGenerateBill}
        />
      ))}
    </section>
  );
});
